import { Upload } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Button,
  MenuItem,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const ProfileSettingsFC: React.FC<AppProps> = props => {
  const { user } = props
  const [displayName, setDisplayName] = React.useState('Fullname')
  const displayNameOptions = ['Fullname', 'Nickname']

  return (
    <Box display={'flex'} flexDirection={'column'} padding={2}>
      <Box
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-evenly'}
        borderBottom={1}
        paddingBottom={2}
      >
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <Avatar
            src={user.image !== undefined ? user.image.url : ''}
            sx={{ height: '150px', width: '150px', marginBottom: '10px' }}
          />
          <Button variant={'contained'} startIcon={<Upload />} size={'small'}>
            Change Picture
          </Button>
        </Box>
        <Box>
          <Typography variant={'h4'} align={'center'}>
            {user.firstName} {user.lastName}
          </Typography>
          {user.groups.length > 0 && (
            <Typography variant={'h4'} fontStyle={'italic'} align={'center'}>
              ({user.groups[0].name})
            </Typography>
          )}
        </Box>
      </Box>
      <Box display={'flex'} flexDirection={'column'} minWidth={590} padding={2}>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            Nickname:{' '}
          </Typography>
          <TextField type={'text'} placeholder={'Aaron'} sx={{ width: 0.5 }} />
        </Box>
        <Box display={'flex'} alignItems={'center'} padding={1}>
          <Typography variant={'h6'} flexGrow={1} width={0.5}>
            Display name:{' '}
          </Typography>
          <TextField
            type={'text'}
            select
            sx={{ width: 0.5 }}
            value={displayName}
            onChange={event => {
              setDisplayName(event.target.value)
            }}
          >
            {displayNameOptions.map(option => (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const ProfileSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileSettingsFC)

export default ProfileSettings
